import styled from 'styled-components'

export const Wrapper = styled.div`
  background-color: #fff;
  border-radius: 2px;
  margin: 20px 0 3px 0;
`

export const AccordionButton = styled.button`
  width: 100%;
  padding: 16px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border: none;
  background: none;
  text-align: left;
`

export const AccordionHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`

export const AccordionTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
`

export const Label = styled.p`
  font-size: 12px;
  line-height: 14px;
  font-weight: 400;
`

export const Text = styled.p`
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
`

export const Description = styled.div`
  width: 100%;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  padding: 0px 16px 16px;

  ul {
    margin-top: 30px;

    li {
      margin-bottom: 20px;
      padding-left: 10px;
      list-style: none;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`
